import { openContextModal } from "@mantine/modals";
import * as Analytics from "@shared/lib/Analytics";
import i18next from "i18next";

import { ModalParams } from "./ConfirmPurchaseWithPersonalInfoInputModal";

export const openConfirmPurchaseWithPersonalInfoModal = (props: ModalParams) => {
	const { analyticsData, onClose, ...innerProps } = props;

	void Analytics.site.openConfirmPurchaseWithPersonalInformation({
		...analyticsData
	});

	return openContextModal({
		modal: "confirmPurchaseWithPersonalInfoModal",
		title: i18next.t("login_from_email.message"),
		innerProps: { ...innerProps, onClose },
		size: "md",
		centered: true
	});
};
